import HelpCircle from "@uui/HelpCircle";

import InfoPanel from "@rui/InfoPanel";

const TopicReportsAlert = () => (
  <InfoPanel icon={<HelpCircle />} severity="info" title="What are Readouts?">
    Readouts reports provide a summary of key topics that are being discussed in
    your connected sources (email and messaging). Readouts are only visible to
    you by default, and are never automatically shared.
  </InfoPanel>
);

export default TopicReportsAlert;
